import React, { useState } from "react";
import { BookOpenIcon } from "@heroicons/react/outline";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { classNames } from "../../../../Utils";
import BusinessHeader from "../../Business/BusinessHeader";

const sections = {
  main: {
    label: "menu.mainMenu",
    items: [
      {
        id: "cashbook",
        text: "menu.cashbook",
        icon: BookOpenIcon,
        path: "/v2/cash-book",
      },
    ],
  },
};

const MenuItem = ({ icon: Icon, text, isActive, onClick, path }) => {
  const { t } = useTranslation();

  const baseClasses =
    "group border-l-4 px-4 sm:px-6 py-2 inline-flex w-full items-center text-sm font-medium";
  const activeClasses =
    "bg-teal-50 border-blue-500 text-blue-700 hover:bg-teal-50 hover:text-blue-700";
  const inactiveClasses =
    "border-transparent text-gray-900 hover:bg-gray-50 hover:text-gray-900";

  const classes = `${baseClasses} ${
    isActive ? activeClasses : inactiveClasses
  }`;

  if (path) {
    return (
      <Link to={path} className={classes}>
        <Icon
          className={`flex-shrink-0 -ml-1 mr-2 h-6 w-6 ${
            isActive
              ? "text-blue-500"
              : "text-gray-400 group-hover:text-gray-500"
          }`}
        />
        <span className="truncate">{t(text)}</span>
      </Link>
    );
  }

  return (
    <button type="button" onClick={onClick} className={classes}>
      <Icon
        className={`flex-shrink-0 -ml-1 mr-2 h-6 w-6 ${
          isActive ? "text-blue-500" : "text-gray-400 group-hover:text-gray-500"
        }`}
      />
      <span className="truncate">{t(text)}</span>
    </button>
  );
};

const CashbookSidebar = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const renderSection = (sectionKey) => {
    const section = sections[sectionKey];
    return (
      <div key={sectionKey} className="mb-4">
        <span className="px-4 sm:px-6 text-xs font-semibold text-gray-500 uppercase tracking-wider">
          {t(section.label)}
        </span>
        <nav className="mt-2 space-y-1">
          {section.items.map((menu) => (
            <MenuItem
              key={menu.id}
              {...menu}
              text={t(menu.text)}
              isActive={location.pathname === menu.path}
            />
          ))}
        </nav>
      </div>
    );
  };

  return (
    <aside className="py-6 lg:col-span-3">
      <BusinessHeader onToggleSidebar={toggleSidebar} />
      <div
        className={classNames(isSidebarOpen ? "block" : "hidden", "lg:block")}
      >
        {Object.keys(sections).map(renderSection)}
      </div>
    </aside>
  );
};

export default CashbookSidebar;
